<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18.5 15L18.5 19.5C18.5 20.0523 18.0523 20.5 17.5 20.5L4.5 20.5C3.94771 20.5 3.5 20.0523 3.5 19.5L3.5 7C3.5 6.44771 3.94772 6 4.5 6L9 6" stroke="black"/>
  <path d="M20.4999 4L10.5 14" stroke="black"/>
  <path d="M13 4H20.5V11.5" stroke="black"/>
</svg>
